import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardAccessComponent, ModalComponent } from '@tecalisdev/infinity';

interface IModalWorkflowFormEvent {
	eventType: undefined | 'assisted' | 'json' | 'default';
	event?: Event;
}

@Component({
	selector: 'app-modal-workflow-form',
	imports: [TranslatePipe, ModalComponent, CardAccessComponent],
	templateUrl: './modal-workflow-form.component.html',
	styleUrl: './modal-workflow-form.component.scss',
})
export class ModalWorkflowFormComponent implements OnInit {
	@Input() isNewWorkflow: boolean = true;
	@Output() closeEvent = new EventEmitter<IModalWorkflowFormEvent>();

	public modalMode = 'CREATE';

	ngOnInit(): void {
		this.modalMode = this.isNewWorkflow ? 'CREATE' : 'EDIT';
	}

	public closeModal(eventType: undefined | 'assisted' | 'json' | 'default' = undefined, event?: Event): void {
		this.closeEvent.emit({ eventType, event });
	}
}
